export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const makeHeaderPath = (contentIdx: number) => [
  'jobDetail', 'cta', 0,
  'submitJobSection', 'content', contentIdx,
  'headerSection',
] as const;